import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import { httpOk, GET } from 'helpers/api'

function Index({ addProduct, addedProducts = {}, currentMenuId, showRightBar, setShowRightBar }) {
	const { t } = useTranslation()

	const [menus, setMenus] = useState([])
	const [products, setProducts] = useState([])
	const [productsDuplicate, setProductsDuplicate] = useState([])
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterData, setFilterData] = useState({ menu_ids: [] })
	const [hideAdded, setHideAdded] = useState(false)

	const visibleProducts = hideAdded ? products.filter(item => !addedProducts[item.product_id]) : products

	function addedText(added) {
		return added.menuId === currentMenuId
			? t('external_menu_already_here')
			: t('external_menu_already_in', { name: added.menuName })
	}

	async function searchWithFilter() {
		var filterUrl = "/external-menu-catalog"
		var urlParams = ""

		filterUrl += urlParams
		const response = await GET(filterUrl, {}, { loader: true })

		if (httpOk(response)) {
			setMenus(response.data.menus)
			setProducts(response.data.products)
			setProductsDuplicate(response.data.products)
		}
	}

	function search(searchValue = '', selectedMenus = filterData.menu_ids) {
		// Если фильтры пустые — возвращаем всё

		if (!searchValue && (!selectedMenus || selectedMenus.length === 0)) {
			setProducts(productsDuplicate);
			setDropdownIsOpen(false)
			return;
		}

		const searchLow = searchValue.toLowerCase();

		// Извлекаем только ID из выбранных в Select опций
		const selectedIds = selectedMenus ? selectedMenus.map(m => m.id) : [];

		const result = productsDuplicate.filter(item => {
			// 1. Проверка по тексту (имя продукта или имя меню)
			const matchesText = !searchValue ||
				item?.name?.toString().toLowerCase().includes(searchLow) ||
				item?.menu_name?.toString().toLowerCase().includes(searchLow);

			// 2. Проверка по выбранным меню (по ID)
			// Предполагаем, что у продукта есть поле external_group_id или menu_id
			const matchesMenu = selectedIds.length === 0 ||
				selectedIds.includes(item.external_group_id) ||
				selectedIds.includes(item.menu_id);

			return matchesText && matchesMenu;
		});

		setProducts(result)
		setDropdownIsOpen(false)
	}

	function toggleRightBar() {
		search('')
		setShowRightBar(false)
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{showRightBar &&
				<>
					<div className="right-sidebar-background"
						onClick={() => toggleRightBar()}>
					</div>

					<div className="right-sidebar">
						<div className="position-relative">
							<div className="rightbar-close-icon"
								onClick={() => toggleRightBar()}>
								<i className="uil uil-times"></i>
							</div>
						</div>

						<div className="p-2">
							<h3 className="mb-3">{t('products')}</h3>


							<div className="d-flex gap-2">
								<div>
									<input type="text" className="form-control mb-3"
										placeholder={t('search')}
										onChange={(e) => search(e.target.value)}
									/>
								</div>

								<div>
									<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
										<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
											{t('filter')}
										</Dropdown.Toggle>

										<Dropdown.Menu className="dropdown-filter">
											<div className="row">
												<div className="form-group ">
													<label>{t('menu')}</label>
													<Select
														isMulti
														isClearable
														options={menus}
														value={filterData.menu_ids}
														onChange={(options) => setFilterData({ ...filterData, 'menu_ids': options ? options : null })}
														placeholder=""
														noOptionsMessage={() => t('list_empty')}
														getOptionLabel={(option) => option.name}
														getOptionValue={(option) => option.id}
													/>
												</div>
											</div>
											<div className="row mt-3">
												<div className="col-md-12">
													<div className="d-flex justify-content-end gap-2">
														<button className="btn btn-secondary"
															onClick={() => setDropdownIsOpen(false)}>
															{t('cancel')}
														</button>
														<button className="btn btn-primary"
															onClick={() => search()}>
															{t('apply')}
														</button>
													</div>
												</div>
											</div>
										</Dropdown.Menu>
									</Dropdown>
								</div>
							</div>

							<div className="form-check mb-2">
								<input id="rightbar-hide-added" type="checkbox" className="form-check-input"
									checked={hideAdded}
									onChange={(e) => setHideAdded(e.target.checked)} />
								<label className="form-check-label" htmlFor="rightbar-hide-added">
									{t('external_menu_hide_added')}
								</label>
							</div>

							<div className="table-responsive" style={{ 'height': 'calc(100vh - 150px)' }}>
								<table className="table table-bordered mb-0">
									<thead>
										<tr>
											<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
											<th style={{ 'width': '60%' }}>{t('name2')}</th>
											<th style={{ 'width': '40%' }}>{t('menu')}</th>
											<th style={{ 'minWidth': '33px' }} className="text-center"></th>
										</tr>
									</thead>
									<tbody>
										{visibleProducts?.map((item, index2) => {
											// Товар уже в меню сервиса: в этой категории — зелёным, в другой — жёлтым.
											// Второй раз его не добавить (бэкенд отклонит дубль), поэтому вместо «+» значок
											const added = addedProducts[item.product_id]
											const inCurrent = added && added.menuId === currentMenuId
											return (
												<tr key={item.product_id} className={added ? (inCurrent ? 'table-success' : 'table-warning') : ''}>
													<td className="text-center">{index2 + 1}</td>
													<td>
														{item.name}
														{added &&
															<div className="fz-12 text-muted">{addedText(added)}</div>
														}
													</td>
													<td>{item.menu_name}</td>
													<td>
														{added ?
															<div className="text-center" title={addedText(added)}>
																<i className={'uil fz-18 ' + (inCurrent ? 'uil-check text-success' : 'uil-exchange text-warning')}></i>
															</div>
															:
															<div className="table-action-button table-action-success-button"
																onClick={() => addProduct(item)}>
																<i className="uil-plus"></i>
															</div>
														}
													</td>
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>
						</div>

					</div>
				</>
			}
		</>
	)
}

export default Index